"use client";

import React, { createContext, useContext, useState } from "react";

export type SidebarContextType = {
  isOpened: boolean;
  activeTab: string;
  setIsOpened: (value: boolean) => void;
  setActiveTab: (value: string) => void;
};

interface SidebarContextProviderPropTypes {
  children: React.ReactNode;
  initialState?: object;
}

const SidebarContext = createContext<SidebarContextType>({
  isOpened: false,
  activeTab: "Dashboard",
  setIsOpened: () => {},
  setActiveTab: () => {},
});

export const useSidebarCtx = () => {
  return useContext(SidebarContext);
};

export const SidebarContextProvider = ({
  children,
  initialState = {},
}: SidebarContextProviderPropTypes) => {
  const [isOpened, setIsOpened] = useState(false);
  const [activeTab, setActiveTab] = useState("Dashboard");

  const value: SidebarContextType = {
    isOpened,
    setIsOpened,
    activeTab,
    setActiveTab,
    ...initialState,
  };

  return (
    <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>
  );
};
